import { create } from "zustand";
import { MasterListItem } from "pages/accountant/finance/types";

export type MasterInvoiceStoreState = {
  list: { isLoaded: boolean; data: MasterListItem[] };
  setList: (list: { isLoaded: boolean; data: MasterListItem[] }) => void;
  isChangeStatusInProcess: { [objectId: number]: boolean };
  setIsChangeStatusInProcess: (
    updater:
      | { [objectId: number]: boolean }
      | ((prevState: {
          [objectId: number]: boolean;
        }) => { [objectId: number]: boolean })
  ) => void;
  isPaymentInProcess: { [objectId: number]: boolean };
  setIsPaymentInProcess: (
    updater:
      | { [objectId: number]: boolean }
      | ((prevState: {
          [objectId: number]: boolean;
        }) => { [objectId: number]: boolean })
  ) => void;
  isTableHidden: boolean;
  setIsTableHidden: (
    updater: boolean | ((prevState: boolean) => boolean)
  ) => void;
};

const useMasterInvoiceStore = create<MasterInvoiceStoreState>((set) => ({
  list: {
    isLoaded: false,
    data: [],
  },
  setList: (list) => set({ list }),
  isChangeStatusInProcess: {},
  setIsChangeStatusInProcess: (updater) => {
    if (typeof updater === "function") {
      set((state) => ({
        isChangeStatusInProcess: updater(state.isChangeStatusInProcess),
      }));
    } else {
      set({ isChangeStatusInProcess: updater });
    }
  },
  isPaymentInProcess: {},
  setIsPaymentInProcess: (updater) => {
    if (typeof updater === "function") {
      set((state) => ({
        isPaymentInProcess: updater(state.isPaymentInProcess),
      }));
    } else {
      set({ isPaymentInProcess: updater });
    }
  },
  isTableHidden: true,
  setIsTableHidden: (updater) =>
    set((state) => ({
      isTableHidden:
        typeof updater === "function" ? updater(state.isTableHidden) : updater,
    })),
}));

export default useMasterInvoiceStore;
